import { isPlatformServer } from "@angular/common";
import { inject, PLATFORM_ID } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { CbRoutesUtils } from "@app/@classes/routes/cb-routes-utils";
import { AuthTenantService } from "@app/@services/shared/auth-tenant.service";
import { AuthService } from "@app/@services/shared/auth.service";
import { PalmtopService } from "@app/@services/shared/palmtop.service";
import { ErrorHandlerService } from "@app/@services/shared/error-handler.service";
import { LoggerService } from "@app/@services/shared/logger.service";

export const palmtopCompanyGuard: CanActivateFn = (route, state) => {
	const selectCompanyUrl = CbRoutesUtils.paths.w.palmtop_choose_client.path;
	const router = inject(Router);
	const loggerService = inject(LoggerService);
	const platformId = inject(PLATFORM_ID);
	const companyService = inject(PalmtopService);

	loggerService.logInfo(
		"[CompanyPalmtopGuard] Checking if company is selected",
	);

	const companyId = companyService.getCompanyId();

	if (isPlatformServer(platformId)) {
		return true;
	}

	if (companyId == null || companyId === undefined || companyId === "") {
		loggerService.logWarning(
			"No company selected, navigating to company selection page",
		);
		router.navigate([selectCompanyUrl]);
		return false;
	}

	return true;
};
